import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { PortalProvider } from "./state/PortalContext";
import { router } from "./router";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PortalProvider>
      <RouterProvider router={router} />
    </PortalProvider>
  </React.StrictMode>,
);
